/**
 * SKU List Modal
 *
 * Displays the full list of SKUs for an inventory item.
 * Triggered when clicking "+X more" on inventory items with >3 SKUs.
 *
 * Props:
 * - skuModalData: Contains the SKU list and inventory name, or null if closed
 * - onClose: Callback to close the modal
 */

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { SkuModalData } from "../../types";

interface SkuListModalProps {
  skuModalData: SkuModalData;
  onClose: () => void;
}

export default function SkuListModal({
  skuModalData,
  onClose,
}: SkuListModalProps): JSX.Element {
  return (
    <Dialog open={skuModalData !== null} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>SKUs for {skuModalData?.inventoryName}</DialogTitle>
      <DialogContent>
        <List dense>
          {skuModalData?.skus.map((sku) => (
            <ListItem key={sku}>
              <ListItemText primary={sku} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
